import React from 'react';
import Button from '@prisjakt/ui-button';
import ArrowIcon from 'mdi-react/ArrowTopLeftIcon';
import * as S from './styles';

type Props = {
  index: number;
  text: string;
  selected: boolean;
  onClick: () => void;
  onSuggestionButtonClick: () => void;
};

export default ({
  text,
  index,
  selected,
  onClick,
  onSuggestionButtonClick,
}: Props) => {
  return (
    <S.Item
      onClick={onClick}
      selected={selected}
      style={{ order: index }}
      data-test="SearchSuggestionItem"
    >
      <S.RowInfo>
        <S.IconWrapper>
          <S.SearchIcon />
        </S.IconWrapper>
        {text}
      </S.RowInfo>
      <S.ExtendSearch>
        <Button
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            onSuggestionButtonClick();
          }}
          color="secondary"
          variant="icon"
          icon={<ArrowIcon />}
        />
      </S.ExtendSearch>
    </S.Item>
  );
};
